import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportYieldLinkedFetch } from './actions';

export const sagasReportYieldLinked = [
  takeLatest(actionReportYieldLinkedFetch.rejected, workerErrorNotifyThunk),
];
